import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  eventManager: null,
  complianceTaskData: null,
};

const eventManagerSlice = createSlice({
  name: "eventManager",
  initialState,
  reducers: {
    setNotifications(state, action: PayloadAction<any>) {
      state.eventManager = action.payload;
    },
    setComplianceTaskData(state, action: PayloadAction<any>) {
      state.complianceTaskData = action.payload;
    },
  },
});

export const { setNotifications, setComplianceTaskData } =
  eventManagerSlice.actions;
export default eventManagerSlice.reducer;
